jQuery.noConflict();

jQuery(function() {
    var apiKey = 'cfccb31239be06047d732717c4fa4985';
    var userId = '87073447@N04';
    var tag = '';
    var perPage = '50';
    var showOnPage = '16';
    
    jQuery.getJSON('http://api.flickr.com/services/rest/?format=json&method='+
        'flickr.photos.search&api_key=' + apiKey + '&user_id=' + userId + 
        '&tags=' + tag + '&per_page=' + perPage + '&jsoncallback=?', 
    function(data){
        var classShown = 'class="lightbox"';
        var classHidden = 'class="lightbox hidden"';
        
        jQuery.each(data.photos.photo, function(i, rPhoto){
            var basePhotoURL = 'http://farm' + rPhoto.farm + '.static.flickr.com/'
                + rPhoto.server + '/' + rPhoto.id + '_' + rPhoto.secret;
            
            var thumbPhotoURL = basePhotoURL + '_s.jpg';
            var mediumPhotoURL = basePhotoURL + '.jpg';
            
            var photoStringStart = '<a ';
            var photoStringEnd = 'title="' + rPhoto.title + '" href="'+ 
                mediumPhotoURL +'"><img class="meh" src="' + thumbPhotoURL + '" alt="' + 
                rPhoto.title + '"/></a>;'
            var photoString = (i < showOnPage) ? 
                photoStringStart + classShown + photoStringEnd : 
                photoStringStart + classHidden + photoStringEnd;

            jQuery(photoString).appendTo("#flickr");
        });
        jQuery("a.lightbox").lightBox();
    });
    
    jQuery('a.repairs').hover(function(){
        jQuery('.active-icon').css({'color':'white'}).removeClass('active-icon');
        jQuery(this).find('i').css({'color':'#4396ff'}).addClass('active-icon');
        jQuery('.repairs-m').slideDown();
        jQuery('.parts-m').slideUp();
        jQuery('.customize-m').slideUp();
    });
    jQuery('a.parts').hover(function(){
        jQuery('.active-icon').css({'color':'white'}).removeClass('active-icon');
        jQuery(this).find('i').css({'color':'#4396ff'}).addClass('active-icon');
        jQuery('.parts-m').slideDown();
        jQuery('.repairs-m').slideUp();
        jQuery('.customize-m').slideUp();
    });
    jQuery('a.customize').hover(function(){
        jQuery('.active-icon').css({'color':'white'}).removeClass('active-icon');
        jQuery(this).find('i').css({'color':'#4396ff'}).addClass('active-icon');
        jQuery('.customize-m').slideDown();
        jQuery('.parts-m').slideUp();
        jQuery('.repairs-m').slideUp();
    });
    jQuery('.new-nav-container').mouseleave(function(){
        jQuery('.active-icon').css({'color':'white'}).removeClass('active-icon');
        jQuery('.customize-m').slideUp();
        jQuery('.parts-m').slideUp();
        jQuery('.repairs-m').slideUp();
    });
    jQuery('a.acontact').mouseenter(function(){
        jQuery('.active-icon').css({'color':'white'}).removeClass('active-icon');
        jQuery('.customize-m').slideUp();
        jQuery('.parts-m').slideUp();
        jQuery('.repairs-m').slideUp();
    });
    jQuery('a.tech').mouseenter(function(){
        jQuery('.active-icon').css({'color':'white'}).removeClass('active-icon');
        jQuery('.customize-m').slideUp();
        jQuery('.parts-m').slideUp();
        jQuery('.repairs-m').slideUp();
    });
    
    jQuery('#social-stream').dcSocialStream({
    	feeds: {
    		twitter: {
				id: '/9927875,#designchemical,designchemical',
				thumb: true
			},
			facebook: {
				id: '157969574262873,Facebook Timeline/376995711728'
			},
			google: {
				id: '111470071138275408587'
			},
			youtube: {
				id: 'fixlogik'
			},
			flickr: {
				id: ''
			},
			
		},
		rotate: {
			delay: 0
		},
        twitterId: 'ifixdirect',
        wall: true,
        filter: false,
        max: 'limit',
    	limit: 2,
    	iconPath: 'http://themelogik.com/ifix/dcsns-dark/',
		imagePath: 'http://themelogik.com/ifix/dcsns-dark/'
	});
});